// Za jak dlouho po navigate("/") z výsledků se zkontroluje, jestli se trasa opravdu commitla.
// Zdravá navigace trvá ~0,35 s, 2,5 s je s velkou rezervou a student přitom ještě nestihne rage click. [TD-467]
export const NAV_STALL_MS = 2500;

// Jak dlouho po zjištění zaseknuté navigace čekáme na sondu Scheduleru, než událost odešleme.
export const NAV_STALL_PROBE_MS = 500;
